const Calculations = () => {
  const TotalPromo = booking => {
    // Calculamos el precio total final con AddOns y Promos

    if (booking.promoIsPercentage) {
      const totalPrice = booking.price

      return (totalPrice * (booking.promoValue / 100))
    }

    return booking.promoValue
  }

  const TotalPrice = booking => {
    // Calculamos el precio total final con AddOns y Promos
    let totalPrice = booking.price
    if (booking.promoIsPercentage) {
      totalPrice -= (totalPrice * (booking.promoValue / 100))
    } else {
      totalPrice -= booking.promoValue
    }

    return totalPrice + booking.addOns
  }

  const TotalPaid = booking => booking.paid - booking.refunded

  const ToPay = booking => TotalPrice(booking) - TotalPaid(booking)

  return {
    TotalPrice,
    TotalPaid,
    ToPay,
    TotalPromo,
  }
}

export default Calculations
